import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { api, errMsg, ROLE_LABEL } from "../../lib/api";

const EMPTY = { email: "", name: "", role: "polda", polda: "", active: true };

export const UserFormDialog = ({ open, user, meta, onClose, onSaved }) => {
  const isEdit = !!user?.user_id;
  const [form, setForm] = useState(EMPTY);
  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  useEffect(() => {
    if (open) setForm(isEdit ? { ...EMPTY, ...user, polda: user.polda || "" } : EMPTY);
  }, [open, user, isEdit]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const body = { ...form, polda: form.role === "polda" ? form.polda : null };
      if (isEdit) await api.put(`/users/${user.user_id}`, body);
      else await api.post("/users", body);
      toast.success("Pengguna disimpan");
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-sm" data-testid="user-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{isEdit ? "Ubah Pengguna" : "Daftarkan Pengguna"}</DialogTitle>
          <DialogDescription>Pengguna masuk menggunakan akun Google dengan email ini.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="user-email">Email Google *</Label>
            <Input id="user-email" type="email" required disabled={isEdit} value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="user-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="user-name">Nama / Pangkat</Label>
            <Input id="user-name" value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="user-name-input" />
          </div>
          <div className="space-y-1.5">
            <Label>Peran *</Label>
            <Select value={form.role} onValueChange={(v) => set("role", v)}>
              <SelectTrigger data-testid="user-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {Object.entries(ROLE_LABEL).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          {form.role === "polda" && (
            <div className="space-y-1.5">
              <Label>Polda *</Label>
              <Select value={form.polda} onValueChange={(v) => set("polda", v)}>
                <SelectTrigger data-testid="user-polda-select"><SelectValue placeholder="Pilih Polda" /></SelectTrigger>
                <SelectContent className="max-h-72">
                  {meta.polda_list.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          )}
          <div className="flex items-center justify-between border p-3">
            <Label htmlFor="user-active">Akun aktif</Label>
            <Switch id="user-active" checked={form.active} onCheckedChange={(v) => set("active", v)} data-testid="user-active-switch" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} data-testid="user-form-cancel">Batal</Button>
            <Button type="submit" data-testid="user-form-submit">Simpan</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
